import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "text-greeting-container"
};
import { delReplyById } from '@/api/greeting';
import { ElMessage, ElMessageBox } from 'element-plus';
export default {
  __name: 'index',
  props: {
    greetingList: {
      type: Array,
      required: true
    },
    isVisible: {
      type: Boolean,
      default: false
    }
  },
  emits: ['changeDialogVisible', 'getData', 'editGreetingHandler'],
  setup(__props, {
    emit: __emit
  }) {
    const emits = __emit;

    /**
     * 修改
     */
    const editGreetingHandler = raw => {
      emits('changeDialogVisible', true);
      // form.value = { ...row, isChain: Boolean(row.isChain) }
      emits('editGreetingHandler', raw);
    };

    /**
     * 删除回复消息
     */
    const delGreetingHandler = async raw => {
      try {
        await ElMessageBox.confirm('确认删除吗', '温馨提示', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'warning'
        });

        // 如果该租户的子诊所数量为0的话
        await delReplyById(raw.id);
        emits('getData');
        ElMessage({
          message: '删除成功',
          type: 'success'
        });
      } catch (error) {}
    };
    return (_ctx, _cache) => {
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_table = _resolveComponent("el-table");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_table, {
        data: __props.greetingList,
        border: "",
        style: {
          "width": "100%"
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_el_table_column, {
          label: "序号",
          type: "index",
          width: "80"
        }), _createVNode(_component_el_table_column, {
          prop: "keyword",
          label: "关键字",
          width: "180"
        }), _createVNode(_component_el_table_column, {
          prop: "createTime",
          label: "创建时间",
          width: "180"
        }, {
          default: _withCtx(({
            row
          }) => [_createTextVNode(_toDisplayString(_ctx.$filters.dateFilter(row.createTime)), 1)]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          prop: "modifyTime",
          label: "修改时间",
          width: "180"
        }, {
          default: _withCtx(({
            row
          }) => [_createTextVNode(_toDisplayString(_ctx.$filters.dateFilter(row.modifyTime)), 1)]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          prop: "value",
          label: "消息回复内容"
        }), _createVNode(_component_el_table_column, {
          fixed: "right",
          label: "操作",
          width: "300"
        }, {
          default: _withCtx(({
            row
          }) => [_createVNode(_component_el_button, {
            type: "primary",
            size: "small",
            onClick: $event => editGreetingHandler(row)
          }, {
            default: _withCtx(() => [_createTextVNode(" 修改 ")]),
            _: 2
          }, 1032, ["onClick"]), _createVNode(_component_el_button, {
            type: "danger",
            size: "small",
            onClick: $event => delGreetingHandler(row)
          }, {
            default: _withCtx(() => [_createTextVNode(" 删除 ")]),
            _: 2
          }, 1032, ["onClick"])]),
          _: 1
        })]),
        _: 1
      }, 8, ["data"])]);
    };
  }
};